export { default } from './PageKioskDevice.vue'
